import { useState } from "react"


export const JobListState = () => {
    const [sLoader, setSLoader] = useState(true)
    const [listLoader, setListLoader] = useState(true)
    const [id, setId]= useState()
    const [lSearch, setLSearch]= useState('')
    const [jobpostStatModal, setJobpostStatModal]=useState(false)
    const [repostStatModal, setRepostStatModal]=useState(false)
    const [menuDropdown, setMenuDropdown] = useState('');
    const [lid, setLid] = useState()
    const [inftScroll, setInftScroll] = useState(true)
    const [jobStatus,setJobStatus] = useState([])
    


  return {
    sLoader: {data: sLoader, set: setSLoader},
    id: {data: id, set: setId}, 
    lSearch: {data: lSearch, set: setLSearch},
    jobpostStatModal:{data:jobpostStatModal, set:setJobpostStatModal},
    repostStatModal:{data:repostStatModal, set:setRepostStatModal},
    menuDropdown:{data: menuDropdown, set: setMenuDropdown},
    inftScroll:{data: inftScroll, set: setInftScroll}, 
    lid:{data: lid, set: setLid},
    listLoader: {data: listLoader, set: setListLoader},
    jobStatus: {data: jobStatus, set: setJobStatus},  
  }
}
